<header class="flex header">
  <h2>{{ 'Duca_Modal_Details' | translateWF: 'DUCA Details' }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<div class="content">
  <!-- URL Input and Fetch Button -->
  @if (canEdit) {
    <section>
      <div class="mb-4 grid-12">
        <div class="span-12">
          <label>{{ 'Duca_Modal_URL' | translateWF: 'URL' }}</label>
          <p class="text-sm text-gray-600 mb-1">
            To extract a URL from an image with a QR code, please visit
            <a href="https://scanqr.org/" target="_blank" class="text-blue-600 underline">scanqr.org</a>. Upload your image there to scan the QR code. Once you get the URL, copy
            and paste it into the field below.
          </p>

          <div class="form-box-row">
            <input type="text" class="p-inputtext p-component w-full" [formControl]="url" placeholder="{{ 'Duca_Modal_Insert_URL' | translateWF: 'Insert URL to get data' }}" />
          </div>
        </div>

        <div class="span-3 flex items-end">
          <p-button class="w-full" (click)="fetchDataFromUrl()" [disabled]="isLoadingCustomsData">
            {{ isLoadingCustomsData ? ('Duca_Modal_Charging' | translateWF: 'Charging...') : ('Duca_Modal_Get_Data' | translateWF: 'Get Data') }}
          </p-button>
        </div>
      </div>

      <div class="row-end-stretch">
        <p-button class="mainAction" (click)="toggleDataPopulation()" [disabled]="!customsData">
          {{ isDataPopulated ? ('Duca_Modal_Revert_Data' | translateWF: 'Revert Data') : ('Duca_Modal_Auto_Populate' | translateWF: 'Auto-Populate Data') }}
        </p-button>
      </div>
    </section>
  }

  <!-- Form for DUCA Information -->
  <div *ngIf="ducaInfoForm">
    <div class="grid-12">
      <form [formGroup]="ducaInfoForm" class="span-12">
        <section>
          <h4 class="text-lg font-semibold mb-2">{{ 'Duca_Modal_Duca_Information' | translateWF: 'DUCA Information' }}</h4>
          <div class="span-12">
            <div class="grid-12 gap-[1rem]">
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Duca_Number' | translateWF: 'DUCA Number' }}</label>
                  <input type="text" class="p-inputtext p-component w-full" [formControl]="ducaInfoForm.controls.ducaNumber" />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Customs_Office_Initial' | translateWF: 'Customs Office Initial' }}</label>
                  <input type="text" class="p-inputtext p-component w-full" [formControl]="ducaInfoForm.controls.customsOfficeInitial" />
                </div>
              </div>
            </div>
            <div class="span-6">
              <div class="form-box">
                <label>{{ 'Duca_Modal_Customs_Office_Destination' | translateWF: 'Customs Office Destination' }}</label>
                <input type="text" class="p-inputtext p-component w-full" [formControl]="ducaInfoForm.controls.customsOfficeDestination" />
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>

    <div class="grid-12">
      <form [formGroup]="transportForm" class="span-12" *ngIf="transportForm">
        <section>
          <h4 class="text-lg font-semibold mb-2">
            {{
              'Duca_Modal_Transport_Information'
                | translateWF
                  : 'Transport
            Information'
            }}
          </h4>
          <div class="span-12">
            <div class="grid-12 gap-[1rem]">
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Transport_Code' | translateWF: 'Transport Code' }}</label>
                  <input type="text" class="p-inputtext p-component w-full" [formControl]="transportForm.controls.code" />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Transport_Name' | translateWF: 'Transport Name' }}</label>
                  <input type="text" class="p-inputtext p-component w-full" [formControl]="transportForm.controls.name" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>

    <form [formGroup]="supportingDocsForm" *ngIf="supportingDocsForm">
      <div>
        <h4 class="text-lg font-semibold mb-2">
          {{
            'Duca_Modal_Supporting_Documents'
              | translateWF
                : 'Supporting
          Documents'
          }}
        </h4>
        <span *ngFor="let m of supportingDocsForm.value.supportingDocumentIds; let index = index" class="w-fit bg-gray-100 border px-2 py-1 rounded text-sm row-start-center gap-1">
          {{ m }}
        </span>
      </div>
    </form>

    <div class="grid-12 gap-[1rem]">
      <div class="span-6">
        <div class="form-box">
          <label>{{ 'Duca_Modal_Trailer_IDs' | translateWF: 'Trailer IDs' }}</label>
          <input
            pTooltip="{{ 'Duca_Modal_Add_Trailer_ID' | translateWF: 'Add Trailer ID and press Enter' }}"
            tooltipPosition="right"
            pInputText
            type="text"
            class="p-inputtext p-component w-full"
            #newTrailerInput
            (keydown.enter)="addTrailerId(newTrailerInput.value); newTrailerInput.value = ''; $event.preventDefault()"
            [disabled]="!canEdit"
          />
        </div>
        <span *ngFor="let id of trailerIds; let index = index" class="w-fit bg-gray-100 border px-2 py-1 rounded text-sm row-start-center gap-1">
          {{ id }}
          <i class="pi pi-times text-red-600 cursor-pointer" (click)="removeTrailerId(index)"></i>
        </span>
        <br />
      </div>
      <div class="span-6">
        <div class="form-box">
          <label>{{ 'Duca_Modal_Marchamos_Numbers' | translateWF: 'Marchamos Numbers' }}</label>
          <input
            type="text"
            class="p-inputtext p-component w-full"
            #newMarchamoInput
            (keydown.enter)="addMarchamo(newMarchamoInput.value); newMarchamoInput.value = ''; $event.preventDefault()"
            [disabled]="!canEdit"
          />
        </div>
        <span *ngFor="let m of marchamosNumbers; let index = index" class="w-fit bg-gray-100 border px-2 py-1 rounded text-sm row-start-center gap-1">
          {{ m }}
          <i class="pi pi-times text-red-600 cursor-pointer" (click)="removeMarchamo(index)"></i>
        </span>
      </div>
    </div>

    <form [formGroup]="exporterForm" class="span-12" *ngIf="exporterForm">
      <section>
        <h4 class="text-lg font-semibold mb-2">
          {{
            'Duca_Modal_Exporter_Information'
              | translateWF
                : 'Exporter
          Information'
          }}
        </h4>
        <div class="grid-2 gap-[1rem]">
          <div class="span-1">
            <div class="form-box">
              <label>{{ 'Duca_Modal_Exporter_Name' | translateWF: 'Exporter Name' }}</label>
              <input type="text" class="p-inputtext p-component w-full" [formControl]="exporterForm.controls.nameOrSocialReason" />
            </div>
          </div>
        </div>
      </section>
    </form>

    <div class="grid-12">
      <form [formGroup]="totalValuesForm" class="span-12" *ngIf="totalValuesForm">
        <section>
          <h4 class="text-lg font-semibold mb-2">{{ 'Duca_Modal_Total_Values' | translateWF: 'Total Values' }}</h4>
          <div class="span-12">
            <div class="grid-12 gap-[1rem]">
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Local_Currency' | translateWF: 'Local Currency' }}</label>
                  <input type="text" class="p-inputtext p-component w-full" [formControl]="totalValuesForm.controls.localCurrency" />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Exchange_Rate' | translateWF: 'Exchange Rate' }}</label>
                  <input type="number" class="p-inputtext p-component w-full" [formControl]="totalValuesForm.controls.exchangeRate" />
                </div>
              </div>
              <div class="span-6">
                <div class="form-box">
                  <label>{{ 'Duca_Modal_Total_Value_USD' | translateWF: 'Total Value in USD' }}</label>
                  <input type="number" class="p-inputtext p-component w-full" [formControl]="totalValuesForm.controls.totalValueInUSD" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
<footer class="row-end-stretch gap-4">
  @if (canEdit) {
    <p-button class="w-full" [label]="'Add' | translateWF: 'Add'" (click)="onSave()" />
  }
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
